import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './InputMasks.scss';

const HiddenInputMaskButton = ({
  isOpen,
  onOpen,
  hasWarning,
  popupTriggerRef,
  children,
  inputID,
  ariaLabel,
  errors,
}) => (
  // eslint-disable-next-line jsx-a11y/role-supports-aria-props -- aria-invalid informs the user if there is an error associated with the input
  <button
    onClick={onOpen}
    type="button"
    id={inputID}
    className={clsx('automation-date-picker-popup-btn position-relative border radius-container-sm color-border-emphasis focus-light pad-1-lr',
      styles.hiddenAccessibilityButton,
      { [styles.hasWarning]: hasWarning || errors })}
    ref={popupTriggerRef}
    tabIndex={isOpen ? -1 : 0}
    aria-haspopup="dialog"
    aria-controls="date_popup"
    aria-expanded={isOpen}
    aria-hidden={isOpen}
    aria-label={ariaLabel}
    aria-invalid={hasWarning}
    aria-describedby={`${inputID}-status-message`}
  >
    {children}
  </button>
);
HiddenInputMaskButton.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  hasWarning: PropTypes.bool,
  inputID: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  popupTriggerRef: PropTypes.shape({
    current: PropTypes.shape({
      select: PropTypes.func,
    }),
  }),
  onOpen: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
};

HiddenInputMaskButton.defaultProps = {
  popupTriggerRef: null,
  hasWarning: false,
};

export default HiddenInputMaskButton;
